import React from "react";
import PropTypes from 'prop-types';

import copyToClipboard from "utils/copyToClipboard";
import { useToast } from "utils/context/ToastContext";
import isMobileDevice from "utils/mobileAndTabletCheck";

import { StyledButton } from "ui/StyledComponents/StyledButton";
import { StyledCard } from "ui/StyledComponents/StyledCard";

import VisibilityIcon from '@mui/icons-material/Visibility';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Typography, Tooltip } from "@mui/material";

const SlugEditor = ({ organization, onOrganizationChange, onPreviewModalOpen }) => { 
  const { showToast } = useToast();

  const handleChange = ({ target: { value } }) => {
    const newOrganization = { ...organization, slug: value };
    onOrganizationChange(newOrganization);
  };
  
  const onCopy = () => {
    copyToClipboard(organization.external_url, showToast);
  };

  const isMobile = isMobileDevice();

  return (
    <StyledCard>
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: "flex", flexGrow: 1, alignItems: "center", flexDirection: isMobile ? "column" : "row", gap: 1 }}>
          <Box 
            component="form" 
            sx={{ 
              display: 'flex', 
              flexGrow: 1, 
              alignItems: 'center',
              border: '1px solid rgba(0,0,0,0.1)',
              borderRadius: 1,
              overflow: 'hidden',
              width: isMobile ? '100%' : 'auto',
            }}
            onSubmit={(e) => { e.preventDefault(); }}
          >
            <Box 
              sx={{ 
                bgcolor: 'rgba(0,0,0,0.03)', 
                py: 1, 
                px: 2, 
                borderRight: '1px solid rgba(0,0,0,0.1)'
              }}
            >
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                https://membrz.club/
              </Typography>
            </Box>

            <Tooltip title={organization.newsletter_sender_created ? "Please contact support to change your username" : ""}>
              <input
                type="text"
                value={organization.slug}
                onChange={handleChange}
                style={{
                  flexGrow: 1,
                  padding: '8px 12px',
                  border: 'none',
                  outline: 'none',
                  fontSize: '14px',
                  backgroundColor: 'white',
                }}
                placeholder="username"
                disabled={organization.newsletter_sender_created}
              />
            </Tooltip>
          </Box>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <Tooltip title={"Copy Club Profile link"}>
              <StyledButton 
                  variant="outlined" 
                  size="small" 
                  onClick={onCopy}
              >
                <ContentCopyIcon fontSize="small" />
              </StyledButton>
            </Tooltip>
              
            <Tooltip title={"Preview Club Profile"}>
              <StyledButton 
                variant="outlined" 
                size="small" 
                onClick={onPreviewModalOpen}
            >
              <VisibilityIcon fontSize="small" />
              </StyledButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </StyledCard>
  );
};

SlugEditor.propTypes = {
  organization: PropTypes.object,
  onOrganizationChange: PropTypes.func,
  onPreviewModalOpen: PropTypes.func,
};

export default SlugEditor;